export { default } from "./CreateClaim.gql";
